import {
  Button,
  ResourceComponentProps,
  SelectInput,
  useDataProvider,
  useNotify,
  useRecordContext,
  useRefresh,
} from "react-admin";
import { CustomDataProvider } from "../../../../network/DataProvider";
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField as MuiTextField } from "@material-ui/core";
import { Field, Form } from "react-final-form";
import { useEffect, useState } from "react";
import { MachineDefinitionGroup } from "./models";

export interface MachineDefinitionTelemetryGroupEditProps {
  group: MachineDefinitionGroup;
}

export const MachineDefinitionTelemetryGroupEdit = (props: ResourceComponentProps & MachineDefinitionTelemetryGroupEditProps) => {
  const dataProvider = useDataProvider<CustomDataProvider>()
  const record = useRecordContext(props);
  const refresh = useRefresh();
  const notify = useNotify();

  const [isOpen, setIsOpen] = useState(false);
  const [groups, setGroups] = useState<MachineDefinitionGroup[]>([]);

  useEffect(() => {
    // @ts-ignore
    dataProvider.getMachineGroups(props.id)
      .then(({ data }) => {
        setGroups(data);
      })
    // @ts-ignore
  }, [props.id, dataProvider]);

  const handleDialogClose = () => {
    setIsOpen(false);
  };

  const handleSubmit = async (
    values: any
  ) => {
    try {
      await dataProvider.updateMachineGroup(record.id, { groupId: props.group.id, name: values.name, parentId: values.parentId });
      refresh();
      setIsOpen(false);
      notify("MachineGroup updated", { type: "info" });
    } catch (error) {
      notify("Error updating MachineGroup", { type: "error" });
    }
  };

  const validate = (values: any) => {
    const errors: Record<string, string> = {};
    if (!values.name || values.name.trim() === '') {
      errors.name = 'Name is required';
    }
    return errors;
  };

  return (
    <>
      <Button
        label="ra.action.edit"
        onClick={() => setIsOpen(true)}
      />
      <Dialog
        open={isOpen}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Edit Group</DialogTitle>
        <DialogContent>
          <Form
            onSubmit={handleSubmit}
            validate={validate}
            initialValues={{ name: props.group.name, parentId: props.group.parentId }}
            render={({ handleSubmit, submitting, pristine }) => (
              <form onSubmit={handleSubmit}>
                <Field name="name">
                  {({ input, meta }) => (
                    <MuiTextField
                      {...input}
                      label="Group Name"
                      variant={"filled"}
                      fullWidth
                      error={meta.touched && Boolean(meta.error)}
                      helperText={meta.touched && meta.error}
                    />
                  )}
                </Field>
                <SelectInput
                  source="parentId"
                  options={{ label: "Group" }}
                  allowEmpty
                  optionValue={"id"}
                  emptyText={"None"}
                  emptyValue={null}
                  choices={groups}
                  fullWidth
                />

                <DialogActions>
                  <Button
                    type="submit"
                    color="primary"
                    variant="contained"
                    label={"Save "}
                    disabled={submitting || pristine}
                  />
                </DialogActions>
              </form>
            )}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
